import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { SliderType, layoutOptions } from "./types/prop-types";
import { Variants } from "@kameleon-util/global-theme";

/** Slider Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockTheme: BlockTheme.light,
};

const SliderComponent = ({
  tagline,
  SecondaryBlock,
  slides,
  header,
  description,
  layoutProps,
}: SliderType) => {
  return (
    <Box className="primary-slider-centered-large-image-v1">
      <Box className="padding-global">
        <Box className="container-large">
          <Box className="padding-section-large">
            {(header || description) && (
              <Box className="margin-bottom margin-large">
                <Box className="max-width-large inline-block">
                  {tagline && (
                    <Box className="margin-bottom margin-xsmall">
                      <Variants.TagLine>{tagline}</Variants.TagLine>
                    </Box>
                  )}
                  {header && (
                    <Box className="margin-bottom no-margin-sides">
                      <Variants.Heading as="h2">{header}</Variants.Heading>
                    </Box>
                  )}
                  {description && (
                    <Variants.ParagraphMedium>
                      {description}
                    </Variants.ParagraphMedium>
                  )}
                </Box>
              </Box>
            )}
            <Variants.Slider
              layoutProps={layoutProps}
              className="testimonial15_component w-slider"
            >
              <Variants.Card className="testimonial15_mask w-slider-mask">
                {Variants.AllowedRandomItems(layoutProps, slides).map(
                  (slide, index) => (
                    <Box key={index} className="testimonial15_slide w-slide">
                      <Box className="w-layout-grid testimonial_mm_content">
                        <Box className="cropped-image-wrapper is--1x1-image">
                          <Variants.Image
                            src={slide.image.url}
                            loading="lazy"
                            alt={slide.image.alt}
                            className="image-w100-h100 is--cropped-image"
                          />
                        </Box>
                        <Box className="testimonial15_content-right">
                          <Box className="margin-vertical margin-medium">
                            <Variants.Heading as="h5">
                              {slide.text}
                            </Variants.Heading>
                          </Box>
                          <Box className="secondary">
                            {renderSecondaryBlock(SecondaryBlock)}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
              </Variants.Card>
              <Variants.LinkButtonSlider className="testimonial15_arrow is-left w-slider-arrow-left" />
              <Variants.LinkButtonSlider
                left={false}
                className="testimonial15_arrow w-slider-arrow-right"
              />
              <Variants.SliderNav className="testimonial15_slide-nav w-slider-nav w-slider-nav-invert w-round" />
            </Variants.Slider>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const SliderComponentWithWebflow = webflowHOC(SliderComponent, ["slider"]);

export const Slider = primaryBlock<SliderType>(
  blockConfig,
  SliderComponentWithWebflow
);
Slider.defaultProps = getDefaultProps<SliderType>(defaults);

export const Element: KameleonElement = {
  component: Slider,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
